<template>
  <div class="body-content">
    <div id="magazine">
      <!-- <div v-for="(item, index) in allPages" :key="`test_${index}`"> -->
      <!-- <img :src="item" alt=""> -->
      <!--        <div :class="`text${index}`" > -->
             <div :class="`text${index}`"  :style="'background:#fff url('+item+');'" style="height:800px">

      <!-- <div class="div singel" style="background-image:url(/static/fanye/0.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/1.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/2.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/3.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/4.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/5.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/6.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/7.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/8.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/9.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/10.jpg)"></div>
      <div class="div singel" style="background-image:url(/static/fanye/11.jpg)"></div> -->
<!--
<div class="btns" style="background: #f0f;">
  <div class="pre" @click="next">
    上一页
  </div>

  <div class="next" @click="previous">
    下一页
  </div>

</div> -->

<!--               <footer v-if="index - 1 !== 0 && index - 1 !== allPages.length - 1" class="current-page">
            <div v-if="(index - 1) % 2 == 0" class="even-numbers">
              {{ index - 1 }}
            </div>
            <div v-else class="odd-number">{{ index - 1 }}</div>
          </footer> -->
      <!-- </div> -->
    </div>
  </div>
  </div>
</template>
<script>
  import {pdf_detail,add_pv} from '@/api/api.js'
  import {
    turn
  } from '@/assets/js/turn.js'

  export default {
    name: "FenMian2",
    data() {
      return {
        id: '', //详情id
        company_id: '', //电子书ID
        per_page: 10,
        page: 1,
        total: '',
        value: "",
        //电子书列表
        allPages: []
      };
    },
    mounted() {

      this.id = this.$route.query.id
      this.detail(this.id)

      let self = this;
      $("#magazine").turn("center");
      $("#magazine").turn("page");


      this.$nextTick(() => {
        $("#magazine").turn({
          display: "double",
          elevation: 50,
          duration: 1000,
          gradients: true,
          autoCenter: true,
          acceleration: true,
          gradients: !$.isTouch,
          page: self.page,
          width: 1152,
          when: {
            turned: function(e, page, pages) {


              //当前页
              console.log("Current view: ", $(this).turn("view"));
              //总页数
              console.log(
                "#magazine has " + $("#magazine").turn("pages") + " pages"
              );
            }
          }
        });

      });


    },
    methods: {
      next(){
        $("#magazine").turn("next");
      },
    previous(){
      $("#magazine").turn("previous");
    },

      //月刊详情，图片列表
      detail(id) {
        let data = {
          id: id
        }
        pdf_detail(data).then(res => {
          // console.log(res.data, "===");
          if (res.code == 1) {
            this.allPages = res.data.cn_pdf_arr
          }
        }).catch(err => {});
      },
      addLocatPath() {
        let data = {
          directions: '电子书',
          path: window.location.href
        }
        add_pv(data).then(res => {}).catch(err => {});
      },

    },
    components: {}
  };
</script>
<style scoped>
  body {
    background: #ccc;
    height: 100vh;
    overflow: hidden!important;
  }
  .btns{  position: fixed; top: 0;left: 0px;}
  .body-content{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    /* background: url(~@/assets/fanye/turn_yellow.jpg) 0 0 repeat; */
  }

  #magazine {
    width: 1152px;
    height: 752px;
    margin: 50px auto!important;
  }

  img {
    width: 100%;
    background: #ffffff;
  }

  #magazine .shadow,
  #magazine.shadow {
    -webkit-box-shadow: 0 4px 10px #666;
    -moz-box-shadow: 0 4px 10px #666;
    -ms-box-shadow: 0 4px 10px #666;
    -o-box-shadow: 0 4px 10px #666;
    box-shadow: 0 4px 10px #666;
  }

  #magazine .turn-page {
    background-color: #ccc;
    background-size: 100% 100%;
  }
  .singel {
    background-size: 100% 100%;
  }
</style>
